const routes = [
  {
    path: '/',
    name: 'PaymentSystem',
    component: () => import('./index.vue'),
    meta: {
      title: 'Платное обучение',
      authorize: [],
    },
    children: [
      {
        path: 'settings',
        name: 'PaymentSettings',
        component: () => import('./pages/PaymentSettings.vue'),
        meta: {
          title: 'Настройки',
          breadcrumbs: {
            parent: 'PaymentSystem',
          },
        },
      },
      {
        path: 'list',
        name: 'AgreementsList',
        component: () => import('./pages/AgreementsList.vue'),
        meta: {
          title: 'Реестр договоров',
          breadcrumbs: {
            parent: 'PaymentSystem',
          },
          authorize: [],
        },
      },
      {
        path: 'certificate-list',
        name: 'CertificateList',
        component: () => import('./pages/CertificateList.vue'),
        meta: {
          title: 'Реестр удостоверений',
          breadcrumbs: {
            parent: 'PaymentSystem',
          },
          authorize: [],
        },
      },
    ],
  },
  {
    path: '/certificate-edit',
    name: 'CertificateEdit',
    component: () => import('./pages/CertificateEdit.vue'),
    meta: {
      breadcrumbs: {
        parent: 'PaymentSystem',
      },
      title: 'Редактирование удостоверения',
      authorize: [],
    },
  },

  {
    path: '/document-constructor/:id',
    name: 'ConstructorDocument',
    component: () => import('./pages/ConstructorDocument.vue'),
    meta: {
      title: 'Политики и положения',
      authorize: [],
      layout: 'empty-layout',
    },
  },
  {
    path: '/document-view/:id',
    name: 'ConstructorDocumentView',
    component: () => import('./pages/ConstructorDocument.vue'),
    meta: {
      layout: 'empty-layout',
      readonly: true,
    },
  },
  {
    path: '/sign-contract/:id',
    name: 'SignContract',
    component: () => import('./pages/SignContract.vue'),
    meta: {
      authorize: [],
    },
  },
  {
    path: '/contract-view/:id',
    name: 'ContractView',
    component: () => import('./pages/ContractView.vue'),
    meta: {
      title: 'Просмотр договора',
      breadcrumbs: {
        parent: 'EducationCourseList',
      },
    },
  },
];

export default routes;
